module.exports = __webpack_public_path__ + "static/media/bloom.8763dce6.jpg";